import React from "react";
import { useThresholds, effColor, effLabel } from "@/context/ThresholdContext";

export default function EffBadge({ value, testid }) {
  const { thresholds } = useThresholds();
  if (value === null || value === undefined)
    return <span className="text-muted-foreground text-sm" data-testid={testid}>-</span>;
  const c = effColor(value, thresholds);
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-mono font-bold"
      style={{ backgroundColor: `${c}22`, color: c }}>
      %{new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(value)}
      <span className="font-sans font-medium opacity-80">{effLabel(value, thresholds)}</span>
    </span>
  );
}
